<div class="payer-cell__text">
  <span class="payer-cell__name">{{ name }}</span>
  @if (aliases) {
    <span class="payer-cell__aliases" [title]="aliases">{{ aliases }}</span>
  }
</div>
